import React from 'react'
import './style.css'
import plusIconSrc from './plus.svg'
import AppPlaceholder from '../AppPlaceholder'
import CreateAppButton from './CreateAppButton'

const GetStartedSection = ({ showErrorNotification }) => (
  <AppPlaceholder>
    <div className="get-started-section">
      <img src={plusIconSrc} alt="plus icon" />
      <span className="get-started-section-question">
        Ready to get started?
      </span>
      <CreateAppButton
        showErrorNotification={showErrorNotification}
        className="get-started-section-button"
      />
    </div>
  </AppPlaceholder>
)

export default GetStartedSection
